<template>
  <form v-on:submit.prevent="submit()">
    <div v-if="isModal" class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
      </header>
      <section class="modal-card-body">
        <slot />
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.$parent.close()">
          {{ $t('button.cancel') }}
        </button>
        <button class="button is-primary">{{ $t('button.save') }}</button>
      </footer>
    </div>
    <div v-else class="section columns is-centered">
      <div class="column is-6 b-portlet">
        <div class="b-portlet-header">
          <div class="subtitle is-4 has-text-primary">{{ title }}</div>
        </div>
        <div class="b-portlet-body">
          <slot />
        </div>

        <div class="b-portlet-footer">
          <slot name="footer" v-if="$slots.footer" />
          <div class="field is-grouped" v-else>
            <div class="control">
              <button class="button is-primary">{{ $t('button.save') }}</button>
            </div>
            <div class="control">
              <router-link class="button is-text" :to="{ name: cancelRoute }">{{
                $t('button.cancel')
              }}</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  name: 'FormContainer',
  inject: ['$validator'],
  props: {
    title: String,
    onSubmit: Function,
    isModal: { type: Boolean, default: true },
    cancelRoute: { type: String, default: 'home' }
  },
  methods: {
    async submit() {
      const self = this
      this.$validator.validateAll().then(result => {
        if (result) {
          self.onSubmit()
        }
      })
    }
  }
}
</script>
